"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iReliablePartnerStatus = exports.iReliablePartnerStatusValue = void 0;
const t = require("io-ts");
exports.iReliablePartnerStatusValue = t.keyof({
    ATTENTION: null,
    BUSINESS_ID_MISSING: null,
    INVESTIGATE: null,
    OK: null,
    PENDING: null,
    STOP: null,
    UNAVAILABLE: null,
    UNKNOWN: null
});
exports.iReliablePartnerStatus = t.intersection([
    t.interface({
        lastCheckedAt: t.number
    }),
    t.partial({
        updatedAt: t.number,
        isStatusChanged: t.boolean,
        participantUuid: t.string,
        value: exports.iReliablePartnerStatusValue
    })
]);
//# sourceMappingURL=reliable-partner-status.js.map